import React, { useEffect, useRef, useState } from 'react';
import * as Yup from 'yup';
import { Formik } from 'formik';
import { Form, Modal } from 'react-bootstrap';
import { handleDelete, handleSubmit as modalSubmit } from '../../components/modals/ModalHelpers';
import DynModal from '../../components/modals/DynModal';
import ButtonCard from '../../components/cards/ButtonCard';
import ButtonGroup from '../../components/modals/ButtonGroup';
import InputField from '../../components/form/InputField';
import PagedTable from '../../components/table/PagedTable';
import Bivema from '../../common/Bivema';

const columnsAzavCertification = [
  { title: 'Status', name: 'status' },
  { title: 'Edit', name: '_links.self.href' },
];

const defaultAzavCertification = {
  status: '',
};

const azavCertificationValidationSchema = Yup.object().shape({
  status: Yup.string()
    .required('Bitte geben Sie einen Status ein.'),
});

const AzavCertification = () => {
  const [update, setUpdate] = useState(false);
  const [selfLink, setSelfLink] = useState();
  const [showDynModal, setShowDynModal] = useState(false);
  const [classNameDynModal, setClassNameDynModal] = useState('dynModal');

  const [azavCertification, setAzavCertification] = useState({
    ...defaultAzavCertification,
  });

  // needed for formik, to pass it to the modal and set the values
  const formikRef = useRef();

  // set Tab Title
  useEffect(() => {
    document.title = 'Azav-Zertifizierung | Stammdaten';
  }, []);

  useEffect(() => {
    if (azavCertification._links !== undefined) {
      setSelfLink(azavCertification._links.self.href);
    }

    // sets formik values
    if (formikRef.current && azavCertification !== formikRef.current.values) {
      formikRef.current.setValues(azavCertification);
    }
  }, [azavCertification]);

  return (
    <div className="container-fluid">
      <ButtonCard title="Azav-Zertifizierung" className="mt-2" setShowDynModal={setShowDynModal}>
        <DynModal
          className={classNameDynModal}
          headerTitle="Azav-Zertifizierung"
          setEntity={setAzavCertification}
          defaultEntity={defaultAzavCertification}
          settersToReset={[setSelfLink]}
          formikRef={formikRef}
          show={showDynModal}
          setShow={setShowDynModal}
          modalBody={(

            <Formik
              innerRef={formikRef}
              initialValues={azavCertification}
              onSubmit={(values, submitProps) => modalSubmit(
                values,
                submitProps,
                setUpdate,
                Bivema.AZAV_CERTIFICATIONS,
                selfLink,
              )}
              validateOnChange={false} // because at the moment on change validates all fields
              validationSchema={azavCertificationValidationSchema}
            >
              {({
                errors, touched, handleSubmit, handleReset, handleChange, values,
              }) => (
                <Form onSubmit={handleSubmit} onReset={handleReset}>
                  <Modal.Body>
                    <Form.Group controlId="azav-certification-group">
                      <InputField
                        value={values.status}
                        handleChange={handleChange}
                        touched={touched.status}
                        errorDescription={errors.status}
                        fieldName="status"
                        placeholder="Status*"
                      />
                    </Form.Group>
                  </Modal.Body>
                  <Modal.Footer>
                    <ButtonGroup
                      handleDelete={() => handleDelete(selfLink, setUpdate)}
                      selfLink={selfLink !== undefined}
                      setShowDynModal={setShowDynModal}
                      setClassNameDynModal={setClassNameDynModal}
                    />
                  </Modal.Footer>
                </Form>
              )}
            </Formik>
        )}
        />
        <PagedTable
          entityName={Bivema.AZAV_CERTIFICATIONS}
          columns={columnsAzavCertification}
          pageSize={10}
          setShowDynModal={setShowDynModal}
          setEntity={setAzavCertification}
          setUpdate={setUpdate}
          update={update}
        />
      </ButtonCard>
    </div>
  );
};

export default AzavCertification;
